export const formatMarketCap = (value, currency = "$") => {
  if (!value && value !== 0) return `${currency}0`;
  const num = typeof value === "number" ? value : parseFloat(value);
  if (isNaN(num)) return `${currency}0`;

  const TRILLION = 1000 * 1000 * 1000 * 1000;
  const BILLION = 1000 * 1000 * 1000;
  const MILLION = 1000 * 1000;

  if (num >= TRILLION) {
    const trillions = num / TRILLION;
    return `${currency}${trillions.toFixed(2)}T`;
  }
  if (num >= BILLION) {
    const billions = num / BILLION;
    return `${currency}${billions.toFixed(2)}B`;
  }
  if (num >= MILLION) {
    const millions = num / MILLION;
    return `${currency}${millions.toFixed(2)}M`;
  }
  return `${currency}${num.toFixed(2)}`;
};

export const formatVolume = (value, currency = "$") => {
  return formatMarketCap(value, currency);
};

export const formatSupply = (value, symbol = "ETH") => {
  if (!value && value !== 0) return "—";
  const num = typeof value === "number" ? value : parseFloat(value);
  if (isNaN(num)) return "—";

  const BILLION = 1000 * 1000 * 1000;
  const MILLION = 1000 * 1000;
  const THOUSAND = 1000;

  // Use up to 4 decimals to avoid rounding away real supply (e.g. 19,997,368 → 19.9974M not 20.00M)
  const fmt = (n) => {
    const s = n.toFixed(4);
    const trimmed = s.replace(/\.?0+$/, "");
    return trimmed === "" ? "0" : trimmed;
  };

  if (num >= BILLION) {
    const billions = num / BILLION;
    return `${fmt(billions)}B ${symbol}`;
  }
  if (num >= MILLION) {
    const millions = num / MILLION;
    return `${fmt(millions)}M ${symbol}`;
  }
  if (num >= THOUSAND) {
    const thousands = num / THOUSAND;
    return `${fmt(thousands)}K ${symbol}`;
  }
  return `${fmt(num)} ${symbol}`;
};

export const formatPrice = (value, currency = "$") => {
  if (!value && value !== 0) return `${currency}0`;
  const num = typeof value === "number" ? value : parseFloat(value);
  if (isNaN(num)) return `${currency}0`;
  return `${currency}${num.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 8 }).replace(/,/g, " ")}`;
};

export const formatROI = (value) => {
  if (!value && value !== 0) return "+0.00%";
  const num = typeof value === "number" ? value : parseFloat(value);
  if (isNaN(num)) return "+0.00%";
  const isPositive = num >= 0;
  return `${isPositive ? "+" : ""}${num.toFixed(2)}%`;
};

export const formatPercentOfATH = (currentPrice, ath) => {
  if (!ath || !currentPrice) return "—";
  const percent = (currentPrice / ath) * 100;
  return `${percent.toFixed(2)}%`;
};
